var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 -85.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 32,
    height: 21,
    transform: "translate(0 85.331)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 87.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 32,
    height: 2.667,
    transform: "translate(0 0)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 32,
    height: 2.667,
    transform: "translate(0 5.222)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 32,
    height: 2.667,
    transform: "translate(0 10.443)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 32,
    height: 2.667,
    transform: "translate(0 15.666)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 16.003,
    height: 11.489,
    transform: "translate(0 85.331)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(1.625 87.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M83.454,160.624l-.258.793h-.834l.675.49-.258.793.675-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-78.84 -157.763)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M83.712,207.19l-.257-.793-.258.793h-.834l.675.49-.258.793.675-.49.674.49-.258-.793.675-.49Z",
    transform: "translate(-78.84 -200.674)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M27.35,207.19l-.257-.793-.258.793H26l.675.49-.258.793.675-.49.674.49-.258-.793.674-.49Z",
    transform: "translate(-26.001 -200.674)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M27.092,160.624l-.258.793H26l.675.49-.258.793.675-.49.674.49-.258-.793.674-.49H27.35Z",
    transform: "translate(-26.001 -157.763)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M83.454,114.85l-.258.793h-.834l.675.49-.258.793.675-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-78.84 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M27.092,114.85l-.258.793H26l.675.49-.258.793.675-.49.674.49-.258-.793.674-.49H27.35Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M139.816,160.624l-.258.793h-.834l.674.49-.258.793.674-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-131.679 -157.763)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M140.074,207.19l-.257-.793-.258.793h-.834l.674.49-.258.793.674-.49.674.49-.258-.793.675-.49Z",
    transform: "translate(-131.679 -200.674)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M196.437,207.19l-.257-.793-.258.793h-.834l.674.49-.258.793.675-.49.674.49-.258-.793.675-.49Z",
    transform: "translate(-184.518 -200.674)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M196.179,160.624l-.258.793h-.834l.674.49-.258.793.675-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-184.518 -157.763)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M139.816,114.85l-.258.793h-.834l.674.49-.258.793.674-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-131.679 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M196.179,114.85l-.258.793h-.834l.674.49-.258.793.675-.49.674.49-.258-.793.675-.49h-.834Z",
    transform: "translate(-184.518 -114.85)",
    fill: "#f0f0f0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/FlagIcon.bc0d2c4e2fb13c2edc471cc9e65a5254.svg";
export { ForwardRef as ReactComponent };